import { useEffect, useState } from "react";
import { staticUrl } from "../../config";

export default function useOptimisedBg({ folder, prefix, key, optimised = true }) {
  const [bg, setBg] = useState("");

  useEffect(() => {
    if (!key) return;

    const webpUrl = optimised
      ? `${staticUrl}/img_optimised/${folder}/${prefix}_${key}.webp`
      : null;
    const jpgUrl = `${staticUrl}/img/${folder}/${prefix}_${key}.jpg`;

    if (!optimised) {
      setBg(`url(${jpgUrl})`);
      return;
    }

    const img = new window.Image();
    img.onload = () => setBg(`url(${webpUrl})`);
    img.onerror = () => setBg(`url(${jpgUrl})`);
    img.src = webpUrl;
  }, [key, folder, prefix, optimised]);

  return bg;
}